export default "__VITE_ASSET__DQdF_Zgm__"